export default __webpack_public_path__ + "static/media/Case-study-documentation.61e2a484.jpg";